<template>
    <header class="igp-header">
        <div class="nav-sec">
            <div class="igp-container">
                <ul class="nav-social">
                    <!-- <span>Síguenos en: </span> -->
                    <li>
                        <a href="https://www.facebook.com/igp.peru"
                            ><i class="fab fa-facebook-f" aria-hidden="true"></i
                        ></a>
                    </li>
                    <li>
                        <a href="https://twitter.com/igp_peru"
                            ><i class="fab fa-twitter" aria-hidden="true"></i
                        ></a>
                    </li>
                    <li>
                        <a href="https://www.linkedin.com/company/igpperu/"
                            ><i
                                class="fab fa-linkedin-in"
                                aria-hidden="true"
                            ></i
                        ></a>
                    </li>
                    <li>
                        <a href="https://www.instagram.com/igp.peru"
                            ><i class="fab fa-instagram" aria-hidden="true"></i
                        ></a>
                    </li>
                    <li>
                        <a href="https://www.linkedin.com/company/igpperu/"
                            ><i class="fab fa-youtube" aria-hidden="true"></i
                        ></a>
                    </li>
                    <li>
                        <a href="https://www.flickr.com/people/156092703@N08/"
                            ><i class="fab fa-flickr" aria-hidden="true"></i
                        ></a>
                    </li>
                </ul>
                <ul class="nav-contact">
                    <li>
                        <a href=""
                            ><i class="fas fa-phone" aria-hidden="true"></i>
                            (511) 3172300</a
                        >
                    </li>
                    <li>
                        <a href="mailto:comunicaciones@igp.gob.pe"
                            ><span
                                ><i
                                    class="fas fa-envelope"
                                    aria-hidden="true"
                                ></i>
                                comunicaciones@igp.gob.pe</span
                            ></a
                        >
                    </li>
                </ul>
            </div>
        </div>

        <nav class="nav-main">
            <div class="igp-container">
                <ul class="nav-left">
                    <li>
                        <a href=""
                            ><img
                                src="https://www.igp.gob.pe/informacion-institucional/themes/igp-static/images/logo-minan.png"
                                alt=""
                                class="logo"
                        /></a>
                    </li>
                    <li class="dp-small">
                        <a href="dp-small"
                            ><img
                                src="https://www.igp.gob.pe/informacion-institucional/themes/igp-static/images/logo_igp_small.png"
                                alt=""
                                class="logo logo-igp"
                        /></a>
                    </li>
                    <li class="dp-normal">
                        <a href=""
                            ><img
                                src="https://www.igp.gob.pe/informacion-institucional/themes/igp-static/images/logo_igp_normal.png"
                                alt=""
                                class="logo logo-igp"
                        /></a>
                    </li>
                </ul>

                <nav class="main">
                    <button type="button" :class="[ isActive ? 'active' : '', 'btn-nav' ]" target="#navmain" @click="activate">
                        <span class="btn-navicon"></span>
                    </button>
                    <ul :class="{ active : isActive }">
                        <Menu
                            v-for="(item, index) in menu"
                            :key="index"
                            :menu="item"
                        ></Menu>
                    </ul>
                </nav>
            </div>
        </nav>
    </header>
</template>
<script>
import Menu from "@/components/Menu.vue";

export default {
    name: "Header",

    props: {
        menu: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            isActive: false
        }
    },
    methods: {
        activate() {
            this.isActive = !this.isActive
            this.$emit('update-overlay', this.isActive)
        }
    },
    components: {
        Menu,
    },
};
</script>
